import React from 'react';
import { FiberManualRecord } from '@mui/icons-material';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { RootStateType } from '@Store';

interface UserReportCardProps {
  type?: string;
  url: string | null;
  createdAt?: string;
  status?: string;

  // ✅ NEW PROPS
  loading?: boolean;
  error?: string | null | boolean;
}

// Function to update the label based on the type
const updateLabel = (typeToMatch: string) => {
  const options = [
    { type: 'ACCOUNTS', label: 'Account Detailed' },
    { type: 'ACCOUNTS_SUMMARY', label: 'Accounts Summary' },
    { type: 'CS', label: 'Customer Service Detailed' },
    { type: 'OP', label: 'Operation Detailed' },
    { type: 'SALES', label: 'Sales Detailed' },
    { type: 'ALL', label: 'Shipment Report Detailed' },
    { type: 'CS_SUMMARY', label: 'Customer Service Summary' },
    { type: 'OP_SUMMARY', label: 'Operation Summary' },
    { type: 'SALES_SUMMARY', label: 'Sales Summary' },
    { type: 'ALL_SUMMARY', label: 'Shipment Report Summary' },
    { type: 'USER_SUMMARY', label: 'Shipment Report Summary' },
  ];

  const matchedOption = options.find(option => option.type === typeToMatch);
  return matchedOption ? 'Shipment Report' : typeToMatch;
};

const UserReportCard: React.FC<UserReportCardProps> = ({ type, url, createdAt, status, loading, error }) => {
  const label = type ? updateLabel(type) : undefined;

  const userName = useSelector((state: RootStateType) => state.loginUser.token?.name);

  const downloadStatus = useSelector((state: RootStateType) => state.basePricingRateSheetDownload);

  const handleDownload = () => {
    if (url && !loading && !error) {
      window.open(url, '_blank');
    }
  };

  // ✅ preserve old logic + add new props
  const isLoading = loading || downloadStatus?.downloadStatus === 'loading' || url === '';

  const isError = !!error || status === 'failed';

  const buttonText = isLoading ? 'In Progress' : 'Click here to download';

  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '16px',
        border: '2px solid #d5d5d5',
        display: 'flex',
        gap: '10px',
        flexDirection: 'column',
        color: '#212062',
        cursor: isLoading ? 'not-allowed' : 'pointer',
        marginTop: '10px',
      }}
      onClick={handleDownload}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <p className="notification-grey xss-text">{userName}</p>

        <FiberManualRecord className="notification-grey" sx={{ color: 'background.grey', width: '0.5rem' }} />

        <p className="notification-grey xss-text">{dayjs(createdAt)?.fromNow()}</p>
      </div>

      <p style={{ fontSize: '16px', fontWeight: '500' }}>{label}</p>

      <p
        style={{
          color: isError ? '#d32f2f' : isLoading ? '#aaa' : '#212062',
          borderRadius: '4px',
          border: 'none',
          transition: 'background-color 0.2s',
          width: 'fit-content',
          fontSize: '14px',
        }}
      >
        {isError ? 'Failed to download, Please try again' : buttonText}
      </p>
    </div>
  );
};

export default UserReportCard;
